export enum ChosenConditionType {
  NONE,
  TIME,
  STATE,
  LOCATION,
  WEATHER,
  PRICE,
}
